import React from 'react';
import PropTypes from 'prop-types';
import StyledSvg from '../styledSvg';

const IconUrbanisme = ({ color, size }) => (
  <StyledSvg fill={color} size={size} viewBox="0 0 40 48" xmlns="http://www.w3.org/2000/svg">
    <g fill="#B68962" fillRule="nonzero">
      <path d="M40 47.5H0V.5h40v47zm-38-2h36v-43H2v43z" />
      <path d="M17 38.5h2v8h-2zM21 38.5h2v8h-2zM13 17.5H5v-8h8v8zm-6-2h4v-4H7v4zM24 17.5h-8v-8h8v8zm-6-2h4v-4h-4v4zM35 17.5h-8v-8h8v8zm-6-2h4v-4h-4v4z" />
      <g>
        <path d="M13 32H5v-8h8v8zm-6-2h4v-4H7v4zM24 32h-8v-8h8v8zm-6-2h4v-4h-4v4zM35 32h-8v-8h8v8zm-6-2h4v-4h-4v4z" />
      </g>
    </g>
  </StyledSvg>
);

IconUrbanisme.propTypes = {
  /** Should be a valid css color in a string */
  color: PropTypes.string,
  /** Should be a the value in px */
  size: PropTypes.number,
};

IconUrbanisme.defaultProps = {
  color: '#000',
  size: 50,
};

export default IconUrbanisme;



// WEBPACK FOOTER //
// ./src/app/components/icons/IconUrbanisme.jsx